module.exports = __webpack_public_path__ + "img/隐藏.a371a13a.svg";